var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Box, DialogTitle as MuiDialogTitle, styled, Typography, } from '@mui/material';
import Close16 from '@yunex/yds-icons/components/Close16';
import React, { cloneElement, isValidElement } from 'react';
import { ICON_SIZE_MAP } from '../../utils/constants';
import { resolveSvgIcon } from '../../utils/internalUtils';
import { resolveSxAsArray } from '../../utils/utils';
import Button from '../Button';
import SvgIcon from '../SvgIcon';
import { rem } from '../../utils/rem';
// Styles.
var styles = {
    icon: function (iconSize) { return ({
        height: iconSize ? rem(ICON_SIZE_MAP[iconSize]) : rem(32),
        margin: 2,
        marginInlineStart: 3,
        width: iconSize ? rem(ICON_SIZE_MAP[iconSize]) : rem(32),
    }); },
    iconWrapper: {
        color: 'text.secondary',
        display: 'grid',
        height: 1,
        minHeight: rem(56),
        placeItems: 'center',
    },
};
// Components.
var SMuiDialogTitle = styled(MuiDialogTitle, {
    name: 'MuiDialogTitle',
    shouldForwardProp: function (prop) { return !['filled', 'icon'].includes(prop.toString()); },
    overridesResolver: function (_a) {
        var icon = _a.icon, filled = _a.filled, theme = _a.theme;
        return [
            icon && [theme.components.MuiDialogTitle.customOverrides.header],
            filled && [theme.components.MuiDialogTitle.customOverrides.filled],
            icon && filled && [theme.components.MuiDialogTitle.customOverrides.iconAndFilled],
        ];
    },
})({});
var STypography = styled(Typography, {
    name: 'MuiDialogTitle',
    shouldForwardProp: function (prop) { return prop !== 'icon'; },
    overridesResolver: function (_a) {
        var icon = _a.icon, theme = _a.theme;
        return [
            theme.components.MuiDialogTitle.customOverrides.title,
            icon && theme.components.MuiDialogTitle.customOverrides.titleWithIcon,
        ];
    },
})({
    overflowWrap: 'anywhere',
});
var SBox = styled(Box, {
    name: 'MuiDialogTitle',
    shouldForwardProp: function (prop) { return prop !== 'actionButton'; },
    overridesResolver: function (_a) {
        var actionButton = _a.actionButton, onClose = _a.onClose, theme = _a.theme;
        return [
            (actionButton || onClose) &&
                theme.components.MuiDialogTitle.customOverrides.titleBarButtons,
        ];
    },
})({});
var DialogTitle = function (_a) {
    var btn = _a.actionButton, children = _a.children, className = _a.className, icon = _a.icon, iconProps = _a.iconProps, onClose = _a.onClose, filled = _a.filled, titleProps = _a.titleProps, props = __rest(_a, ["actionButton", "children", "className", "icon", "iconProps", "onClose", "filled", "titleProps"]);
    // If someone pass icon as a component, it will fallback to cloneElement and show warning.
    var iconElement = isValidElement(icon) ? (cloneElement(icon, {
        style: __assign({ height: rem(32), margin: rem(16), marginInlineStart: rem(24), width: rem(32) }, icon.props.style),
    })) : (React.createElement(SvgIcon, { component: icon, inheritViewBox: true, sx: __spreadArray([styles.icon(iconProps === null || iconProps === void 0 ? void 0 : iconProps.iconSize)], resolveSxAsArray(iconProps === null || iconProps === void 0 ? void 0 : iconProps.sx), true) }));
    if (isValidElement(icon)) {
        console.warn('[YDS-REACT] - DialogTitle: Passing an icon as a component is not supported. Pass icon object to icon prop instead.');
    }
    var actionBtnIconSize = { width: rem(16), height: rem(16) };
    return (React.createElement(SMuiDialogTitle, __assign({ component: "div" }, __assign({ icon: icon, filled: filled }, props), { className: filled ? 'dialog-title-filled' : '' }),
        icon && React.createElement(Box, { sx: styles.iconWrapper }, iconElement),
        React.createElement(STypography, __assign({}, { icon: icon }, titleProps), children),
        React.createElement(SBox, __assign({ actionButton: btn }, { onClose: onClose }),
            btn && (React.createElement(Button, { "aria-label": btn.ariaLabel, color: "inherit", icon: true, onClick: btn.onClick, sx: { color: 'text.secondary' } }, resolveSvgIcon(btn.icon, actionBtnIconSize, {
                style: actionBtnIconSize,
            }))),
            onClose && (React.createElement(Button, { "aria-label": "close", icon: true, color: "inherit", onClick: onClose, sx: { color: 'text.secondary' } },
                React.createElement(Close16, null))))));
};
export default DialogTitle;
